import { clsx as e } from "../../../../node_modules/clsx/dist/clsx.js";
import { extendTailwindMerge as t } from "../../../../node_modules/tailwind-merge/dist/bundle-mjs.js";
const n = t({
  prefix: "gst-"
});
function c(...r) {
  return n(e(r));
}
export {
  c as cn,
  n as twMerge
};
